import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNI = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.806 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M24.999 0C15.088 0 6.524 5.768 2.479 14.13h45.039C43.474 5.768 34.91 0 24.998 0ZM24.999 50c9.911 0 18.475-5.768 22.519-14.13H2.48C6.524 44.232 15.087 50 24.999 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 17.391a7.609 7.609 0 1 0 0 15.218 7.609 7.609 0 0 0 0-15.218Zm0 11.957a4.348 4.348 0 1 1 0-8.696 4.348 4.348 0 0 1 0 8.696Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M28.765 26.087 25 25l-3.765 1.087-1.255 2.174h10.04l-1.255-2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "m25 19.566-2.51 4.348L25 25l2.51-1.086L25 19.566Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M21.233 26.086h7.531l-1.255-2.173h-5.02l-1.256 2.173Z"
}));
FlagNI.displayName = 'FlagNI';
export default withFlagWrapper(FlagNI);
//# sourceMappingURL=index.js.map